import CryptoJS from 'crypto-js';

/**
 * 密码加密
 * 算法：AES；
 * AES mode：CBC；
 * AES padding: Pkcs7；
 * 默认编码：UTF-8；
 * 密钥 key 和 偏移量 iv 一致
 * @param {string} password 密码
 * @param {string} key 密钥
 * @returns
 * 返回加密后的文本
 */
export const passwordCrypto = (password, key) => {
  if (!password || !key) {
    return '';
  }
  const sUtf8 = str => CryptoJS.enc.Utf8.parse(str);
  return CryptoJS.AES.encrypt(
    sUtf8(password),
    sUtf8(key),
    {
      iv: sUtf8(key),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    },
  ).toString();
};
